import React from 'react';
import NotFoundBlock from '../components/NotFoundBlock';

export const CartNotFound: React.FC = () => {
  return (
    <>
      <NotFoundBlock />
    </>
  );
};
